var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5463_4804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5463_4804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99779 10.8782L5.77021 15.1057C5.65483 15.2211 5.50981 15.2802 5.33512 15.2828C5.16046 15.2855 5.01276 15.2265 4.89204 15.1057C4.77131 14.985 4.71094 14.8387 4.71094 14.6667C4.71094 14.4947 4.77131 14.3483 4.89204 14.2276L9.1196 9.99999L4.89204 5.77241C4.77665 5.65703 4.71762 5.512 4.71496 5.33732C4.71228 5.16266 4.77131 5.01496 4.89204 4.89424C5.01276 4.7735 5.15913 4.71313 5.33113 4.71313C5.50313 4.71313 5.64949 4.7735 5.77021 4.89424L9.99779 9.1218L14.2254 4.89424C14.3408 4.77885 14.4858 4.71982 14.6605 4.71716C14.8351 4.71447 14.9828 4.7735 15.1035 4.89424C15.2243 5.01496 15.2846 5.16132 15.2846 5.33332C15.2846 5.50532 15.2243 5.65168 15.1035 5.77241L10.876 9.99999L15.1035 14.2276C15.2189 14.3429 15.278 14.488 15.2806 14.6627C15.2833 14.8373 15.2243 14.985 15.1035 15.1057C14.9828 15.2265 14.8365 15.2868 14.6645 15.2868C14.4925 15.2868 14.3461 15.2265 14.2254 15.1057L9.99779 10.8782Z",
    fill: "#A82525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7c5cd922bfa81f49b822daae646046e4.svg";
export { ForwardRef as ReactComponent };